<template>
  <div class="yzm-button" :style="{ ...marginStyle, ...btnStyle }" @click="handleGo">{{ item.setting?.btnText }}</div>
  <el-dialog v-model="dialogVisible" width="500">
    <template #title>
      <div :style="{ ...popTitleStyle }">{{ item.setting?.popupTitle }}</div>
    </template>
    <div :style="{ ...popTextStyle }">{{ item.setting?.popupText }}</div>
    <template #footer>
      <el-button type="primary" @click="openLink">确定</el-button>
    </template>
  </el-dialog>
</template>
<script setup>
import { defineProps, computed, ref, onMounted, defineEmits } from 'vue'
import { defaultProps } from './defaultProps'
const props = defineProps({
  ...defaultProps
})
const dialogVisible = ref(false)
const marginStyle = computed(() => {
  let item = props.item.setting
  return {
    marginTop: `${item.marginTop}px`,
    marginBottom: `${item.marginBottom}px`,
    marginLeft: `${item.marginLeft}px`,
    marginRight: `${item.marginRight}px`
  }
})
const btnStyle = computed(() => {
  let item = props.item.setting
  let type = item.btnStyleObj?.btnStyleType
  return {
    fontSize: `${item.fontSize}px`,
    color: item.color,
    background: [1, 3].includes(type) ? item.background : '#ffffff',
    border: [2, 4].includes(type) ? `1px solid ${item.background}` : '',
    borderRadius: [1, 2].includes(type) ? '4px' : '100px'
  }
})
const popTitleStyle = computed(() => {
  let item = props.item.setting
  return {
    color: item.titleBackground,
    textAlign: item.titleAlignT
  }
})
const popTextStyle = computed(() => {
  let item = props.item.setting
  return {
    color: item.textBackground,
    textAlign: item.textAlignT
  }
})
const handleGo = () => {
  let link = props.item.setting.link || 'https://element-plus.org/zh-CN/component/dialog.html'
  if (link && link !== '') {
    if (props.item.setting.switchStatus) {
      dialogVisible.value = true
    } else {
      openLink(url)
    }
  }
}
const openLink = (url) => {
  dialogVisible.value = false
  window.open(url, '__blank')
}
const emit = defineEmits(['childMounted'])
onMounted(() => {
  emit('childMounted')
})
</script>
<style lang="less" scoped>
.yzm-button {
  height: 38px;
  line-height: 38px;
  text-align: center;
}
</style>
